import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
Vue.config.productionTip = false
import { Col, Row ,Form,Field,Button,CellGroup,Uploader,Image as VanImage,Loading} from 'vant';
import 'vant/lib/index.css';
Vue.use(Col).use(Row).use(Form).use(Field).use(Button).use(CellGroup).use(Uploader).use(VanImage).use(Loading)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
